import {
  oneYearAgoDate,
  aWeegAgo,
  thirtyDaysAgoDate,
  threeYearAgoDate,
  todaysDate,
} from "common/helpers/calculateDays";

export const toISODateString = (dateString) => {
  return new Date(dateString).toISOString();
};

const dateMap = {
  daily: todaysDate,
  weekly: aWeegAgo,
  perYear: oneYearAgoDate,
  threeYears: threeYearAgoDate,
  default: thirtyDaysAgoDate,
};
export const handleSelectChange = ({
  e,
  setStartDate,
  isNeedToConverdDateFormat,
}) => {
  const { value } = e.target;
  const selectedDate = dateMap[value] ?? dateMap.default;
  const startDate = isNeedToConverdDateFormat
    ? toISODateString(selectedDate)
    : selectedDate;
  setStartDate(startDate);
};
